import { useData } from "@hooks/useData";
import Http from "@core/fetch";
import { API__SocialLinks } from "@models/api/SocialLinks";
import { iSocialLinks, SocialLinks } from "@models/SocialLinks";
import { components } from "@apiSchema";

async function getSocialLinks(links: components["schemas"]["FFSocialLinks"]): Promise<iSocialLinks> {
    const data: API__SocialLinks = await Http.post(
        'get social links',
        {},
        {
            body: JSON.stringify({ links }),
            headers: {
                "content-type": "application/json; charset=utf-8",
            },
        }
    );

    return new SocialLinks({ apiModel: data });
}

export default function useSocialLinks(arr: components["schemas"]["FFSocialLinks"]) {
    return useData(new SocialLinks(), getSocialLinks, arr)
}